export const updateState = (oldState: any, updatedState: any) => {
  return {
    ...oldState,
    ...updatedState,
  };
};
